export default __webpack_public_path__ + "static/thin-cup-dark-green-568eed68916c85c74e6aabb1c63aa555.png";